<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
             <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="限速备注：">
                <el-input v-model.trim="searchForm.remark" @keyup.enter.native="getListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="运营商：">
                <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="修改时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary"  plain icon="el-icon-search" @click="getListHandler($event)" >查 询</el-button>
                <el-button type="primary" plain @click="singleLimitDialog = true">单卡限速</el-button>
                <el-button type="success" plain @click="dialogVisible=true">批量操作</el-button>
                <el-button type="primary" @click="exportInfoHandle" icon="el-icon-download">导 出</el-button>

            </el-form-item>
        </el-form>


        <el-table :data="tbpg.tableData"
		 border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"
		 :default-sort = "{prop: 'createTime', order: 'descending'}">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="180" align="center"></el-table-column>
            <el-table-column prop="myRemark" label="限速备注" width="250" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="运营商" width="250" align="center"></el-table-column>
             <el-table-column prop="limitName" label="限速方式" width="120" align="center"></el-table-column>
            <el-table-column prop="limitTime" label="限速时间" sortable width="150" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 



        <el-dialog :append-to-body="true"  title="批量操作" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
            <el-form ref="limitForm" :model="limitForm"  label-width="100px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="uploadFile" :action="uploadUrl('sim/limit/speed')" :headers="setHeader()" 
                    :auto-upload="false" :on-success="handleSuccess" :data="limitForm" :on-change="handleChange">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=invest')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                 <!-- <el-form-item label="限速ID" prop="limitSpeed">
                    <el-input v-model="limitForm.limitSpeed" placeholder="请输入限速ID"></el-input>
                </el-form-item> -->
                <el-form-item label="限速类别：" prop="limitSpeed">
                    <el-select v-model="limitForm.limitSpeed" clearable>
                        <el-option v-for="item in limitList" :key="item.code" :value="item.code"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="限速备注" prop="myRemark">
                    <el-input v-model="limitForm.myRemark" placeholder="限速备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler">确 定</el-button>
            </div> 
        </el-dialog>


        <el-dialog :append-to-body="true"  title="单卡限速" :visible.sync="singleLimitDialog" width="600px" :close-on-click-modal="false">
            <el-form ref="limitForm" :model="singleLimitForm" label-width="100px">
                <el-form-item label="iccid：" prop="iccid">
                    <el-input v-model="singleLimitForm.iccid" placeholder="请输入iccid"></el-input>
                </el-form-item>
                 <!-- <el-form-item label="限速ID" prop="limitSpeed">
                    <el-input v-model="singleLimitForm.limitSpeed" placeholder="请输入限速ID"></el-input>
                </el-form-item> -->

                <el-form-item label="限速类别：" prop="limitSpeed">
                    <el-select v-model="singleLimitForm.limitSpeed" clearable>
                        <el-option v-for="item in limitList" :key="item.code" :value="item.code"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="限速备注" prop="myRemark">
                    <el-input v-model="singleLimitForm.myRemark" placeholder="限速备注"></el-input>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelsSngleLimit()">取 消</el-button>
                <el-button type="primary" @click="singleLimitSpeed()">确 定</el-button>
            </div> 
        </el-dialog>


    </div>
</template>
<script>
import common from '@/utils/common.js';
import {flowStatistics, flowEveryDayDetail, flowEveryMonthDetail, flowStatisticsExport1} from '@/api/csm.js'
export default {
    data(){
        return {
            limitList: [
                { label: '速率恢复', code: '0' },
                { label: 'APN-AMBR=1Mbps', code: '1' },
                { label: 'APN-AMBR=3Mbps', code: '2' },
                { label: 'APN-AMBR=5Mbps', code: '3' },
            ],

            pkgGroup: [],
            searchForm: {
                iccid: '',
                supplierCode: '',
                basePkgGroup: '',
                remark: '',
            },
            branchSupplierOption:[],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            //批量操作
            dialogVisible: false,
            limitForm:{
                supplierCode: null,
                limitSpeed: null,
                myRemark:''
            },
            statusGroup: [],
            limitFormRules:{
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            //批量操作  end

            //单卡限速操作
            singleLimitDialog: false,
            singleLimitForm:{
                iccid: null,
                limitSpeed: null,
            },
            singleLimitFormRules:{
                iccid:[
                    { required: true, message: '请输入iccid', trigger: 'blur' }
                ],
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        exportInfoHandle(){//导出excel文件
            this.$confirm("确定要导出吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.deleteSpaceKey(this.searchForm); 
                flowStatisticsExport1(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(()=>{});
        },

        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            common.sysRequest('sim/query/limit/speed', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler();
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },
        sureRechargeHandler(){
            if (this.$refs.uploadFile.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    this.$refs.uploadFile.submit();   
                    this.rechargeVisible = false; 
                } 
            });              
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.uploadFile.clearFiles();
        },

        cancel(){
            this.limitForm.limitSpeed = null;
            this.limitForm.supplierCode = null;
            this.dialogVisible = false;
        },

        formatLimitSpeed(code){

            let v =  this.statusGroup.filter(function(item){
                if(code == item.code){
                    return item;
                }
            });
            return v[0]&&v[0].description?v[0].description:"";
        },
        

        singleLimitSpeed(){
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed/type", data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getListHandler();
                            this.cancelsSngleLimit();
                        }else{
                            this.$message.error(res.data.message)
                        }     
                    }).catch(err=> console.error(err));
                } 
            });   
            
        },

        cancelsSngleLimit(){
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },
    },

    computed:{
        
    },

    created () {
        this.getListHandler();
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');

        //获取状态值
        common.sysRequest('sim/limit/speed/status', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.statusGroup = res.data.data;
            }
        })
    },
}
</script>
<style lang="less" scoped>

</style>

